document.addEventListener('DOMContentLoaded', function () {
  var splide = new Splide('.splide', {
    type: 'slide',
    perPage: 8,
    gap: '1rem',
    pagination: true,
    autoWidth: true,
    arrows: false,
    drag: 'free',
    snap: false,
    flickPower: 300,
    autoHeight: true,
    breakpoints: {
      1400: {
        perPage: 5,
      },
      1024: {
        perPage: 5,
      },
      768: {
        perPage: 3,
      },
      480: {
        perPage: 2,
      },
    },
  });
  splide.mount();
});